import { RootState } from '../../RootState';
import selectSessionContent from './selectSessionContent';

const selectShowOverheadComponent = (state: RootState): boolean => {
  const content = selectSessionContent(state);
  return content.showOverheadComponent;
};

export default selectShowOverheadComponent;
